import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import React, { Fragment } from 'react';

interface GenderDistributionProps extends React.HTMLAttributes<HTMLDivElement> {
  male: number;
  female: number;
  other: number;
}

const GenderDistribution: React.FC<GenderDistributionProps> = ({ male, female, other, ...rest }) => {
  const { t } = useTranslation();
  const items = [
    { label: t('Girls'), value: female || 0, image: '/images/follow/girls.webp' },
    { label: t('Boys'), value: male || 0, image: '/images/follow/boys.webp' },
    { label: t('Other'), value: other || 0, image: '/images/follow/others.webp' },
  ];

  return (
    <div className="flex items-center justify-between px-2 text-left cursor-pointer" {...rest}>
      {items.map((item, index) => (
        <Fragment key={index}>
          <div className="flex items-center justify-center gap-3">
            <Image src={item.image} alt={item.label} width={42} height={42} />
            <div className="flex flex-col gap-1">
              <span className="text-[0.875rem] leading-4 text-gray-900">{item.label}</span>
              <div className="text-[1.25rem] leading-4 font-semibold">{item.value}</div>
            </div>
          </div>
          {index < items.length - 1 && <div className="w-px h-6 bg-[#D9D9D9]" />}
        </Fragment>
      ))}
    </div>
  );
};

export default GenderDistribution;
